<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep2ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 금리 안내(정기적금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <div class="tbl-top-etc">{{ /*(연이율, 세전, 단위 : %)*/ $t("MDEP-01-02-01-08") }}</div>
    </div>

    <table class="table -type03">
      <thead>
        <tr>
          <th scope="col">{{ /*기간*/ $t("MDEP-01-02-02-06") }}</th>
          <th scope="col">USD</th>
          <th scope="col">KHR</th>
          <th>{{ /*금리구분*/ $t("MDEP-01-02-02-08") }}</th>
        </tr>
      </thead>

      <tbody v-if="irList.length > 0">
        <tr v-for="(ir, i) in irList" :key="i">
          <td>
            <template v-if="lang === 'KOR'">
              {{ ir.aplyTrmCtntKor }}
            </template>
            <template v-else-if="lang === 'ENG'">
              {{ ir.aplyTrmCtntEng }}
            </template>
            <template v-else>
              {{ ir.aplyTrmCtntLcal }}
            </template>
          </td>
          <td
            v-if="rspanListUsdRateNA[i] !== 0"
            :rowspan="rspanListUsdRateNA[i]"
          >
            {{ ir.usdRate }}
          </td>
          <td
            v-if="rspanListKhrRateNA[i] !== 0"
            :rowspan="rspanListKhrRateNA[i]"
          >
            {{ ir.khrRate }}
          </td>
          <td>
            <template v-if="lang === 'KOR'">
              {{ ir.irtDsticCtntKor }}
            </template>
            <template v-else-if="lang === 'ENG'">
              {{ ir.irtDsticCtntEng }}
            </template>
            <template v-else>
              {{ ir.irtDsticCtntLcal }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="info info-etc">· {{ /*영업점 내점상담 후, 금리 결정*/ $t("MDEP-01-02-02-21") }}</div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  components: {},
  data() {
    return {
      currentTab: 1,

      irList: [],

      rspanListUsdRateNA: [],
      rspanListKhrRateNA: [],
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },

  created() {
    this.go();
  },

  methods: {
    go() {
      const path = "/deposit/interest/intRateKh1List";

      let params = {
        interestInqInItemDTO: {
          aplyStartYmd: "",
          cncycd: "",
          dpostLnDstcd: "D",
          operGroupCd: "KH1",
          ppsnCorpCtnt: "",
          prdctKndCtnt: "KH103"
        },
      };

      this.$post(
        path,
        params,
        this.selectSucc
      );
    },

    selectSucc(res) {
      this.irList = res.interstList;

      let length = this.irList.length;

      this.rspanListUsdRateNA = Array.from({length}, () => 0);
      this.rspanListKhrRateNA = Array.from({length}, () => 0);

      let target1 = undefined;
      let pointer1 = 0;

      let target2 = undefined;
      let pointer2 = 0;

      for(let i=0; i<length; i++){
        // 금리 USD rspan
        if(_.trim(this.irList[i].usdRate) === "N/A" && target1 === _.trim(this.irList[i].usdRate)){
          this.rspanListUsdRateNA[pointer1]++;
        } else {
          target1 = _.trim(this.irList[i].usdRate);
          this.rspanListUsdRateNA[i]++;
          pointer1 = i;
        }

        // 금리 KHR rspan
        if(_.trim(this.irList[i].khrRate) === "N/A" && target2 === _.trim(this.irList[i].khrRate)){
          this.rspanListKhrRateNA[pointer2]++;
        } else {
          target2 = _.trim(this.irList[i].khrRate);
          this.rspanListKhrRateNA[i]++;
          pointer2 = i;
        }
      }

    },
  },
};
</script>
